<script setup>
import { default as ButtonEl } from '@/components/shared/Button.vue';

const emit = defineEmits(['archive-add', 'archive-remove']);

defineProps({
  allowArchiveRemove: {
    type: Boolean,
    default: false,
  },
  mediaType: {
    type: String,
    default: '',
  },
});

function archiveAdd() {
  emit('archive-add');
}

function archiveRemove() {
  emit('archive-remove');
}
</script>

<template>
  <div class="flex items-center justify-center">
    <ButtonEl
      v-if="!allowArchiveRemove"
      :text="`media.addToMy.${mediaType}`"
      :icon="['fal', 'fa-cloud-download']"
      background="bg-green-400"
      class="shadow-xsm mb-10"
      typography="h700"
      rounded="full"
      @click="archiveAdd()"
    />

    <ButtonEl
      v-else
      :text="`media.removeFromMy.${mediaType}`"
      :icon="['fal', 'fa-trash-alt']"
      background="bg-red-400"
      rounded="full"
      class="shadow-xsm mb-10"
      typography="h700"
      @click="archiveRemove()"
    />
  </div>
</template>
